import script from "./InstructionTrendCRMPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionTrendCRMPage.vue?vue&type=script&setup=true&lang=js"

import "./InstructionTrendCRMPage.vue?vue&type=style&index=0&id=7f9c5e2c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f9c5e2c"]])

export default __exports__